import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { canSeeTraderArea } from '@/shared/consts/traders';

import { ROUTE_PATHS } from 'shared/consts/routes';
import { useTypedSelector } from 'store';

export const TraderRoute = ({ children }: PropsWithChildren) => {
  const user = useTypedSelector(store => store.auth.user);

  if (!user) return <Navigate to={ROUTE_PATHS.login} replace />;
  if (!canSeeTraderArea(user)) return <Navigate to="/" replace />;

  return <>{children}</>;
};
